
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-8ad757da\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":false}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=styles&index=0!./TcInputAdvantages.vue")

var Component = require("!../../../../../../../shared/frontend/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./TcInputAdvantages.vue"),
  /* template */
  require("!!../../../../../../../shared/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8ad757da\"}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./TcInputAdvantages.vue"),
  /* scopeId */
  "data-v-8ad757da",
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/releases/136/frontend/src/views/Techcenter/components/TcInputAdvantages.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TcInputAdvantages.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8ad757da", Component.options)
  } else {
    hotAPI.reload("data-v-8ad757da", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Techcenter/components/TcInputAdvantages.vue
// module id = 978
// module chunks = 1